import React, { useMemo } from 'react';
import { Box, useTheme } from '@mui/material';
import { AreaChart, Area, ResponsiveContainer, YAxis } from 'recharts';
import { DivePoint } from '../types/Dive';

interface DiveSparklineProps {
  diveProfile: DivePoint[];
  height?: number;
}

/**
 * Compact, glanceable depth-over-time shape for a feed card — deliberately no axes,
 * tooltip, or annotations. DiveProfileChart (used on the full dive detail page) covers
 * the annotated view; this is the smaller, at-a-glance sibling.
 */
const DiveSparkline: React.FC<DiveSparklineProps> = ({ diveProfile, height = 60 }) => {
  const theme = useTheme();
  const data = useMemo(
    () => diveProfile.map((p, i) => ({ i, depth: -p.depth })),
    [diveProfile]
  );

  if (data.length < 2) return null;

  return (
    <Box sx={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
          <YAxis hide domain={['dataMin', 0]} />
          <Area
            type="monotone"
            dataKey="depth"
            stroke={theme.palette.primary.main}
            fill={theme.palette.primary.main}
            fillOpacity={0.2}
            strokeWidth={2}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default DiveSparkline;
